import Images from './Images'

const seoConfig = {
  title: 't(seo.title)',
  subtitle: 't(seo.subtitle)',
  description: 't(seo.description)',
  image: Images.SEO.Image,
  social: {
    facebook: 'https://www.facebook.com/empruntemontoutou/',
    instagram: 'https://www.instagram.com/empruntemontoutou/',
  },
}

export default seoConfig
